import React from "react";
import exclamation_mark from "../../images/WarningIcon.svg";
import color_close from "../../images/color_close.svg";
import clock from "../../images/ClockIcon.svg";
import correct from "../../images/correct.svg";
import info from "../../images/info.svg";
import colorInfo from "../../images/color_info.svg";
import redInfo from "../../images/info_red.svg";

import {
  EXCLAMATION_ICON_TYPE,
  SUCCESS_ICON_TYPE,
  INFORMATION_ICON_TYPE,
  COLOR_INFO_ICON_TYPE,
  COLOR_CLOSE_ICON_TYPE,
  RED_INFO_ICON_TYPE
} from "../../utils/constants";

const Icon = [exclamation_mark, correct, clock, info, colorInfo, color_close, redInfo];

const InformationCard = (props) => {
  const {
    iconType,
    title,
    message,
    primaryButtonInfo,
    secondaryButtonInfo
  } = props.data;
  let iconSrc = Icon[2];
  if (iconType === EXCLAMATION_ICON_TYPE) {
    iconSrc = Icon[0];
  } else if (iconType === SUCCESS_ICON_TYPE) {
    iconSrc = Icon[1];
  } else if (iconType === INFORMATION_ICON_TYPE) {
    iconSrc = Icon[3];
  } else if (iconType === COLOR_INFO_ICON_TYPE) {
    iconSrc = Icon[4];
  }
  else if (iconType === COLOR_CLOSE_ICON_TYPE) {
    iconSrc = Icon[5];
  }
  else if (iconType === RED_INFO_ICON_TYPE) {
    iconSrc = Icon[6];
  }

  const buttonClickHandler = (e, buttonInfo) => {
    e.preventDefault();
    const { screen, ...otherButtonInfo } = buttonInfo;
    props.goto(screen, { ...otherButtonInfo });
  };
  return (
    <React.Fragment>
      <div className="info-card-icon">
        <img src={iconSrc} alt={iconType} />
      </div>
      <div className="card-header info-card-header">
        <h2>{title}</h2>
        <div dangerouslySetInnerHTML={{ __html: message }} />
      </div>
      <div className="info-card-controls">
        {secondaryButtonInfo && (
          <button
            className="btn btnWhite"
            style={{ width: "100%" }}
            onClick={(e) => buttonClickHandler(e, secondaryButtonInfo)}
          >
            {secondaryButtonInfo?.text}
          </button>
        )}
        {primaryButtonInfo && (
          <button
            className="btn btnRed"
            style={{ width: "100%" }}
            onClick={(e) => buttonClickHandler(e, primaryButtonInfo)}
          >
            {primaryButtonInfo?.text}
          </button>
        )}
      </div>

    </React.Fragment>
  );
};

export default InformationCard;
